import React, { useMemo, useState } from 'react';
import { DatePicker, Row, Col } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const PulseDateRange = ({ dataTimeRange=[1735712606000, 1744007006000], 
  selectedTimeRange=[1735712606000, 1744007006000], 
  onTimeFilterChange}) => {
  const startRange = dayjs(dataTimeRange[0]).startOf('day');
  const endRange = dayjs(dataTimeRange[1]).endOf('day');
  const [currTimeRange, setCurrTimeRange] = useState([dayjs(selectedTimeRange[0]), dayjs(selectedTimeRange[1])])

  useMemo(() => {
    setCurrTimeRange([dayjs(selectedTimeRange[0]), dayjs(selectedTimeRange[1])]);
  }, [selectedTimeRange])
  
  const defaultRangePresets = [
    {
      label: "Last 3 months",
      value: [ dayjs().subtract(3, 'months').startOf('day'), dayjs().subtract(1, 'month').endOf('day') ]
    },
    {
      label: "Last 6 months",
      value: [ dayjs().subtract(6, 'months').startOf('day'), dayjs().subtract(1, 'month').endOf('month') ]
    },
    {
      label: "This Year",
      value: [dayjs().startOf('year').startOf('day'), dayjs().endOf('day')]
    },
    {
      label: "Last Year",
      value: [dayjs().subtract(1, 'year').startOf('year').startOf('day'), dayjs().subtract(1, 'year').endOf('year').endOf('day')]
    },
    {
      label: "All Time",
      value: [startRange, endRange]
    },
  ];
  
  const enabledRangePresets = defaultRangePresets.filter(preset =>
     (preset?.value[0].isSame(startRange) || preset?.value[0].isAfter(startRange))
    && (preset?.value[1].isSame(endRange) || preset?.value[1].isBefore(endRange))  
  )

  const disabledDate = (current) => {
    return current && (current.isAfter(endRange) || current.isBefore(startRange))
  };
  
  const footerMessage = () => {
    const footerStr = `Data Availability Range: ${startRange.format('MMM-YYYY')} to ${endRange.format('MMM-YYYY')}`
    return (<>{footerStr}</>)
  }

  const handleDateChange = (dates) => {
    if (dates?.[0] && dates?.[1]) {
      setCurrTimeRange(dates);
      onTimeFilterChange([dates[0].startOf("month").startOf("day").valueOf(), dates[1].endOf("month").endOf("day").valueOf()]);
    }
  }
  
  return (
    <Row>
      <Col span={24}>
        <RangePicker
          size='large'
          picker='month'
          value={currTimeRange}
          presets={enabledRangePresets}
          allowClear={false}
          disabledDate={disabledDate}
          format={'MMM-YYYY'}
          style={{width:'100%'}}
          suffixIcon={null}
          onChange={handleDateChange}
          renderExtraFooter={footerMessage}
        />
      </Col>
    </Row>
  );
};


export default PulseDateRange;
